/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Helpers.
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';
import getHistory from '../../lib/HistoryHelper';

// Actions.
import { updateBnaData } from '../actions/action-update-bna-data';

const PopularArticles = (props) => {
  const { articles, error, updateBnaData: updateBna } = props;
  const exp = Page.getUserExperience();
  const history = getHistory();
  const popular = {
    common: i18n.message('smarthelp/home.home.common'),
    recommended: i18n.message('smarthelp/home.home.recommended'),
    errorMessage: i18n.message('smarthelp/Error.error.popular'),
  };
  const popularLabel = Page.isLoggedIn() ? popular.recommended : popular.common;
  const goToArticlePage = (currentArticle) => {
    if (currentArticle.channel === 'BNA') {
      updateBna(currentArticle);
    }

    trackLink({ id: 'homePage', link: `smarthelp-common-questions|${currentArticle.articleId}` });
    history.push(`/${exp}/article/${Page.getFormattedUrlForArticle(currentArticle.articleTitle, currentArticle.articleId)}`);
  };

  const handleKeyPress = (event, article) => {
    if (event.which === 13) {
      goToArticlePage(article);
    }
  };

  const renderContents = () => {
    if (error) {
      return <div className="popular-error">{popular.errorMessage}</div>;
    }
    const options = { name: 'home' };
    Page.setCanonicalTag(options);
    if (articles && articles.length > 0) {
      const listItems = articles.map(article =>
        <li
          className="popular-item"
          tabIndex="0"
          key={article.articleId}
          onClick={() => goToArticlePage(article)}
          onKeyPress={event => handleKeyPress(event, article)}
        >
          {article.articleTitle}
        </li>);
      return <ul>{listItems}</ul>;
    }
    return null;
  };

  return (
    <div className="popular-articles">
      <div className="popular-title">{popularLabel}</div>
      <div className="popular-questions">{renderContents()}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    articles: state.popular.articles,
    error: state.popular.error,
  };
}
PopularArticles.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    articleId: PropTypes.string,
    articleTitle: PropTypes.string,
    usage: PropTypes.number,
    channel: PropTypes.string,
    channelDetails: PropTypes.shape({
      bnaId: PropTypes.number,
      bnaListId: PropTypes.number,
      intentId: PropTypes.number,
      intentPromptedTime: PropTypes.string,
    }),
  })),
  error: PropTypes.bool,

  // Method Prop Types.
  updateBnaData: PropTypes.func.isRequired,
};

PopularArticles.defaultProps = {
  articles: [],
  error: false,
};

// Dispatch the Action as Props.
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBnaData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularArticles);



// WEBPACK FOOTER //
// ./home/containers/PopularArticles.js